import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHover } from 'components/Editor/hooks/useHover';
import { Button, Image, ProgressBar, Dropdown } from 'react-bootstrap';

import { toggleEditMode, updateWidgetProperty, updateWidgetContent, actionGroup, updateWidgetLayout, updateWidgetActions, updateBulkWidgetProperty } from 'actions/editor';
import { getBoundingRectFromLayout } from 'components/Editor/helper/layoutManager';
import { useHotspotContainerSelector, useAllowCreateLiveElement, useParentWidgetSelectorForType, useBrandImageContainerSelector } from 'components/Editor/hooks/useEditorSession';
import { HotspotActionButton, HotspotCreationProperty } from '../../components/hotspot';

import { CONTENT_CARD, GROUP, PAGE, SECTION_COLUMN, CONTAINER,CONTENT, CAROUSEL_CARD, MENU, FORM_STEP, CAROUSEL } from 'constants/widgetTypes';
import { POSITION } from 'constants/background';

import _, { set } from 'lodash';
import cx from 'classnames';
import { Frame } from "scenejs";
import { colorToString } from 'components/Editor/helper/color';

import { EditorContext } from '../../index';
import StoryboardContext from 'components/Storyboard/context';
import { Property } from '../../components/properties/';
import { LiveElementCreationProperty } from '../../components/liveElements';
import Actions from '../../components/actions';
import smartGatingIcon from '../../../../assets/images/smartGatingBorder.svg';

import { Animation, AnimationProperty } from 'components/Editor/components/animations';
import { calculateBoundsForElement, getParentContainerOfType, isWidgetHasHotspotChild, getWidgetType, isTopParentIsHotspot } from 'components/Editor/helper/widget';

import { IKImage } from 'imagekitio-react';
import WidgetActions from 'components/Editor/components/properties/widgetActions';
import { ImageCropper } from './crop';
import { MediaLibraryModal } from 'components/MediaLibrary';
import { ContentWidgetContext } from '../content';
import DropShadow from 'components/Editor/components/properties/dropShadow';
import { getDropShadow, getBoxShadow } from 'services/cssHelper.service';

import { generateAltTextForWidget } from 'actions/editor';

import { toast } from "react-toastify";
import { FailureToast, SuccessToast, WarningToast } from "components/Toast";

import { CreateVariableForm, VariableProperty, VaribaleDropdownMenu } from 'components/Editor/components/variables';

import { getMediaInfo } from 'actions/pageHealth';
import { BrandMediaProperty } from 'components/Editor/components/brandElements';
import userRoleService from 'services/userRoles.service';
import { Editor } from '@tinymce/tinymce-react';
import { createVariable } from 'actions/variables';

import styles from './image.module.scss';


const IMAGE_CDN_ENDPOINT = process.env.REACT_APP_IMAGE_CDN;

const ImageWidgetComponent = function ({ className, style, widgetProps, widgetRef }) {
  const dispatch = useDispatch();

  const ref = widgetRef;
  const imageRef = React.useRef(null);
  const eventRef = React.useRef(null);
  const imagePreviewRef = React.useRef(null);

  const editorContext = React.useContext(EditorContext);
  const editor = editorContext.editorSession.id;

  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');
  const content = widgetProps.content;
  const [previewSrc, setPreviewSrc] = React.useState(null);

  const breakpoint = useSelector(state => _.get(state, `${editor}.present.breakpoint`));
  const layout = _.get(widgetProps, `properties.${breakpoint}.layout`);
  const crop = _.get(widgetProps, `properties.${breakpoint}.crop`, false); 
  const alt = _.get(widgetProps, `properties.desktop.alt`, '');
  const border = _.get(widgetProps, `properties.${breakpoint}.border`) || 0;
  const boxShadow = _.get(widgetProps, `properties.${breakpoint}.shadow`, null);
  const parameter = _.get(widgetProps, 'parameter');

  const width = parseFloat(layout.width);
  const height = parseFloat(layout.height); 

  const selected = useSelector(state => {
    const selected = _.get(state, `${editor}.present.selected`) || [];

    return _.size(selected) === 1 && _.includes(selected, id);
  })
  
  const uploads = useSelector(state => _.get(state, 'media.uploads')) || [];

  const getWidgetUpload = () => {
    const uploadForWidget = uploads.find(upload => `widget_loading_${upload.id}` == id);
    if (uploadForWidget) return uploadForWidget;
  };

  const media = getWidgetUpload();
  const instance = media && media.instance;
  const editMode = useSelector(state => {
    return _.get(state, `${editor}.present.editMode`) === id
  });

  useEffect(() => {
    const handleRender = (e) => {
      if (id != e.target.id) {
        return;
      }
      const frame = editorContext.editorSession.moveableData.getFrame(e.target).get();
      const { width, height } = frame;

      cancelAnimationFrame(eventRef.current || 0);
      eventRef.current = requestAnimationFrame(() => {
        if (!imageRef.current) {
          return;
        }

        imageRef.current.imageRef.current.style.width = "100%";
        imageRef.current.imageRef.current.style.height = "100%";
      });
    };
    editorContext.editorSession.eventBus.on('render', handleRender);
    return () => {
      editorContext.editorSession.eventBus.off('render', handleRender);
    };
  }, []);

  useEffect(() => {
    if (instance?.files?.[0]) {
      const file = instance.files[0];
      const reader = new FileReader();
  
      reader.onloadend = () => {
        setPreviewSrc(reader.result);
      };
      reader.readAsDataURL(file);
    }
  }, [instance]);


  const handleCrop = (crop, layoutValue) => {
    dispatch(toggleEditMode(editor, id, false));
    dispatch(updateWidgetProperty(editor, id, breakpoint, {
      crop: crop
    }));

    if (breakpoint !== 'mobile') {
      dispatch(updateWidgetProperty(editor, id, 'mobile', {
        crop: crop
      }));
    }

    const frame = new Frame(layout);
    const parsedRect = getBoundingRectFromLayout(layout);

    frame.set('transform', 'translate', `${parsedRect.x + layoutValue.deltaX}px, ${parsedRect.y + layoutValue.deltaY}px`);
    frame.set('width', `${layoutValue.width}px`);
    frame.set('height', `${layoutValue.height}px`);

    dispatch(updateWidgetLayout(editor, id, breakpoint, frame.get()));
  }

  const widgetStyles = {
    ...getStyles(widgetProps, breakpoint, crop)
  }

  var style = {
    ...style
  }

  var maskStyle = { }

  if(crop){
    const borderStyle = getBorderStyles(border);
    const shadow =  getBoxShadow(boxShadow);
    maskStyle = {
        ...borderStyle,
        ...shadow
      }
  }

  return (
    <>
      <div id={id}
        ref={ref}
        className={cx(className, styles.image, 'widget', 'image_widget')}
        style={style}
        data-widget-id={id}
        data-widget-type={type}
        data-selectable={true}
      >      
      { !id.toLowerCase().startsWith("widget_loading") ? (
        <Animation widget={widgetProps}>
          <div className={styles.maskView} style={maskStyle}>
            <ImageView
              className={cx({ [styles.editing]: editMode })}
              imageRef={imageRef}
              alt={alt}
              content={content}
              width={width}
              height={height}
              style={widgetStyles}
              crop={crop}
              breakpoint={breakpoint}
              parameter={parameter}
            />
          </div>
        </Animation>) : (
          <div className={cx(styles.media, styles.uploading)}>
            <div className={styles.icon}>
              {previewSrc &&
                <img 
                  ref={imagePreviewRef}
                  src={previewSrc}
                  alt="Preview"
                  style={{ maxWidth: '100%', maxHeight: '100%' }}
                />
              }
              <div className={styles.overlay}>
                <div className={styles.actions}>
                  {!media?.processing && (
                    <ProgressBar variant="warning" now={media?.progress || 5} />
                  )}
                  {media?.processing && (
                    <div className={styles.status}>Processing...</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {selected &&
        <ImageCropper
          editorSession={editor}
          images={[content]}
          widgets={[widgetProps]}
          show={editMode}
          width={layout.width}
          height={layout.height}
          crop={crop}
          onCrop={handleCrop}
          onCancel={() => {
            dispatch(toggleEditMode(editor, id, false));
          }}
        />
      }
    </>
  );
}

const imageWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'widgetRef'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

const ImageWidget = React.memo(ImageWidgetComponent, imageWidgetEquals);

const ImageView = ({ className, imageRef, content, width, height, crop, breakpoint, alt, style, parameter }) => {
  const url = _.get(content, 'url');
  const imageWidth = _.get(content, 'width');
  const imageHeight = _.get(content, 'height');

  var transformation = [];

  // What the box gets fitted against below. An explicit crop already narrows
  // the image down to the extracted region, so that region — not the original
  // — is the source for the fit.
  var sourceWidth = parseFloat(imageWidth) > 0 ? parseFloat(imageWidth) : 0;
  var sourceHeight = parseFloat(imageHeight) > 0 ? parseFloat(imageHeight) : 0;

  if (crop && !parameter) {
    transformation.push({
      width: 2 * crop.zoomWidth,
      height: 2 * crop.zoomHeight,
      crop: 'force',
    });

    transformation.push({
      width: 2 * crop.width,
      height: 2 * crop.height,
      cropMode: 'extract',
      x: 2 * crop.x,
      y: 2 * crop.y
    });

    sourceWidth = 2 * crop.width;
    sourceHeight = 2 * crop.height;
  }

  // Ask for the image at its own aspect ratio, scaled just far enough to cover
  // the box and never past the source's own resolution. `c-force` used to
  // stretch the pixels into the box instead, which is what squeezed images
  // whose box came from generated HTML rather than from the media itself.
  // object-fit below fills the box, so the crop happens in the browser.
  var targetWidth = (parseFloat(width) > 0 ? parseFloat(width) : 0) * 2;
  var targetHeight = (parseFloat(height) > 0 ? parseFloat(height) : 0) * 2;

  if (sourceWidth && sourceHeight && (targetWidth || targetHeight)) {
    var scale = Math.min(
      Math.max(targetWidth / sourceWidth, targetHeight / sourceHeight),
      1
    );

    transformation.push({
      width: Math.round(sourceWidth * scale),
      height: Math.round(sourceHeight * scale)
    });
  } else if (targetWidth) {
    // Source dimensions unknown — a height-less resize keeps the source ratio,
    // so the image still cannot come back distorted.
    transformation.push({
      width: Math.round(targetWidth)
    });
  }

  transformation.push({
    quality: 80,
    format: 'webp'
  });

  return (
    <IKImage
      className={className}
      key={breakpoint}
      ref={imageRef}
      lqip={{ active: true, quality: 20 }}
      path={url}
      alt={alt}
      loading="lazy"
      width={"100%"}
      height={"100%"}
      transformation={transformation}
      style={{
        ...style,
        maskImage: crop && crop.mask ? `url(${crop.mask})` : "unset",
        WebkitMaskImage: crop && crop.mask ? `url(${crop.mask})` : "unset",
        borderStyle : crop ? "none" : "solid",
        // The delivered image keeps its own aspect ratio now, so the box is
        // filled here instead of by stretching the pixels at the CDN. A crop
        // already extracts the exact region, so it keeps the default fill.
        objectFit : crop ? undefined : "cover",
        display : "block"
      }}
    />
  );
}

const GEMINI_IMAGE_SUPPORTED_CONTENT_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif',
];
const GEMINI_IMAGE_SUPPORTED_EXTENSIONS = ['jpeg', 'jpg', 'png', 'webp', 'heic', 'heif'];
const UNSUPPORTED_IMAGE_TYPE_MESSAGE =
  'Image personalization is not supported for this image type. Supported formats: JPEG, PNG, WebP.';

const getImageExtension = (value) => {
  if (!value || typeof value !== 'string') {
    return '';
  }

  const clean = value.split('?')[0].split('#')[0];
  const parts = clean.split('.');
  if (parts.length < 2) {
    return '';
  }

  return parts.pop().toLowerCase();
};

const isGeminiSupportedImageType = (content) => {
  if (!content || (!content.id && !content.url && !content.name && !content.contentType && !content.key)) {
    return true;
  }

  const contentType = String(content.contentType || (String(content.type || '').startsWith('image/') ? content.type : '')).toLowerCase();
  if (contentType) {
    return GEMINI_IMAGE_SUPPORTED_CONTENT_TYPES.includes(contentType);
  }

  const extension = getImageExtension(content.name) || getImageExtension(content.url) || getImageExtension(content.key);
  if (!extension) {
    return true;
  }

  return GEMINI_IMAGE_SUPPORTED_EXTENSIONS.includes(extension);
};

const ImageWidgetDesktopAction = (props) => {
  const dispatch = useDispatch();

  const [view, setView] = useState(null);

  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const brandkitEnabled = _.get(workspace, 'brandkitEnabled', false);

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;

  const entityType = _.get(editorContext, 'entityType', null);

  const isHotspotContainer = useHotspotContainerSelector(editorSession, props);
  const allowLiveElement = useAllowCreateLiveElement(editorSession, props);

  const contentWidget = useParentWidgetSelectorForType(editorSession, props.uid, CONTENT);
  const contentType = _.get(contentWidget, 'content.type', 'MANUAL');

  const id = _.get(props, 'uid');
  const parameterised = _.get(props, 'parameter');

  const editMode = useSelector(state => {
    return _.get(state, `${editorSession}.present.editMode`) === id
  });

  const allowVariable = useSelector((state) =>
    _.get(state, `${editorSession}.present.entityType`)) === 'PAGE';
  const brandkitType = useSelector((state) =>
    _.get(state, `${editorSession}.present.entityType`)) !== 'PALETTE_COMPONENT';
  const isBrandImageContainer = useBrandImageContainerSelector(editorSession, props);
  const allowBrandkit = !isBrandImageContainer && brandkitType;  

  const storyboardContext = React.useContext(StoryboardContext);
  const isUnsupportedImageType = !isGeminiSupportedImageType(_.get(props, 'content'));

  useEffect(() => {
    setView(null);
  },[id])

  const changeView = (view) => {
    dispatch(toggleEditMode(editorSession, props.uid, false));
    setView(view);
  }

  const closePopup = () => {
    dispatch(toggleEditMode(editorSession, props.uid, false));
    setView(null);
  }

  const calculateCropSettings = (media, layout) => {
    const naturalWidth = _.get(media, 'width') || 600;
    const naturalHeight = _.get(media, 'height') || 600;

    const currentWidth = parseFloat(layout.width);
    const currentHeight = parseFloat(layout.height);

    if (naturalWidth == currentWidth && naturalHeight == currentHeight) {
      return null;
    }

    const scale = Math.max(currentWidth / naturalWidth, currentHeight / naturalHeight);

    const zoomWidth = naturalWidth * scale;
    const zoomHeight = naturalHeight * scale;

    const x = (zoomWidth - currentWidth) / 2;
    const y = (zoomHeight - currentHeight) / 2;

    return {
      x: x,
      y: y,
      width: currentWidth,
      height: currentHeight,
      zoomWidth: zoomWidth,
      zoomHeight: zoomHeight
    };
  }

  const handleUpdateImage = (medias) => {
    setView(null);

    const media = medias[0];

    const desktopLayoutProperty = _.get(props, 'properties.desktop.layout');
    const desktopMaskProperty = _.get(props, 'properties.desktop.crop.mask');
    let desktopCrop = calculateCropSettings(media, desktopLayoutProperty);

    if(desktopMaskProperty){
      desktopCrop = {
        ...desktopCrop,
        mask: desktopMaskProperty
      }
    }

    const mobileLayoutProperty = _.get(props, 'properties.mobile.layout');
    const mobileMaskProperty = _.get(props, 'properties.mobile.crop.mask');
    let mobileCrop = calculateCropSettings(media, mobileLayoutProperty);

    if(mobileMaskProperty){
      mobileCrop = {
        ...mobileCrop,
        mask: mobileMaskProperty
      }
    }

    actionGroup.start();

    dispatch(updateWidgetContent(props.editorSession, props.uid, media));

    dispatch(updateWidgetProperty(props.editorSession, props.uid, 'desktop', {
      crop: desktopCrop
    }));

    dispatch(updateWidgetProperty(props.editorSession, props.uid, 'mobile', {
      crop: mobileCrop
    }));

    actionGroup.end();
  }

  const handleLiveElement = () => {
    setView('liveElements')
  }

  const handleVariable = () => {
    setView('variables')
  }

  const handleActionChange = (action) => {
    const actions = action ? [action] : [];
    dispatch(updateWidgetActions(editorSession, props.uid, actions));
  }

  const fields = [
    { name: 'Image', path: 'content', type: "IMAGE" }
  ];

  return (
    <>
      {(!parameterised || contentType === 'MANUAL') &&
        <WidgetActions.Action className={styles.textButton} onClick={() => changeView('library')}>Change Image</WidgetActions.Action>
      }
      <WidgetActions.Divider />

      {!parameterised &&
        <>
          <Property.Action tooltip="Insert Link" className={styles.iconButton} onClick={() => changeView('action')}>
            <i className={cx("cleverstory-link")} />
          </Property.Action>
        </>
      }

      <Property.Action tooltip="Border" className={styles.iconButton} onClick={() => changeView('borders')}>
        <i className={cx("cleverstory-corner", styles.gridIcon)} />
      </Property.Action>

      {parameterised &&
        <Property.Action className={styles.iconButton} tooltip='Style' onClick={() => changeView('alignment')}>
          <i className={cx("cleverstory-customize")} />
        </Property.Action>
      }

      <WidgetActions.Action tooltip="Animation" onClick={() => changeView('animation')}>
        <i className={'cleverstory-animations'} />
      </WidgetActions.Action>

      {!parameterised &&
        <>
          <WidgetActions.Action tooltip="Crop" className={styles.cropButton} onClick={() => {
            setView(null);
            dispatch(toggleEditMode(editorSession, props.uid, true));
          }}>
            <i className={'cleverstory-crop'} />
          </WidgetActions.Action>

          {allowLiveElement &&
            <Property.Action className={styles.iconButton} tooltip='Live Element' onClick={handleLiveElement}>
              <i className={'cleverstory-live-element'} />
            </Property.Action>
          }
          {allowVariable && (
            <Property.Action
                className={cx(styles.iconButton, { [styles.disabled]: isUnsupportedImageType })}
                tooltip={isUnsupportedImageType ? UNSUPPORTED_IMAGE_TYPE_MESSAGE : "AI Personalization"}
                onClick={() => {
                  if (isUnsupportedImageType) {
                    return;
                  }
                  changeView("personalization");
                }}
            >
                <i className={"cleverstory-personalization-icon"} />
            </Property.Action>
          )}
          {brandkitEnabled && allowBrandkit && userRoleService.canManageUsers() &&
            <Property.Action className={styles.iconButton} tooltip='Add to Brand Kit' onClick={() => changeView('brandMedia')}>
              <i className={'cleverstory-brandmedia'} />
            </Property.Action>
          }

          {!isHotspotContainer &&
            <HotspotActionButton onClick={() => changeView('hotspot')} widget={props} />
          }

          {allowVariable && 
            <Property.Action className={styles.iconButton} tooltip='Make Variable' onClick={handleVariable}>
              <i className={'cleverstory-variable'} data-track-event="Mixpanel" data-track-props="Make Variable" data-widget-type="Images"/>
            </Property.Action>
          }
          <WidgetActions.Divider />
        </>
      }

      <MediaLibraryModal
        show={view === 'library'}
        storyboard={storyboardContext}
        mediaTypes={['image']}
        onSelect={handleUpdateImage}
        onClose={() => { closePopup() }}
        editorSession = {editorSession}
        target= {_.includes(["live_element", "palette_component"], entityType) ? {
            id: editorContext.editorSession.id.split('_')[1],
            type: entityType
          } : null 
        }
      />

      {!editMode && view === 'alt' &&
        <ImageAltEditor
          id={id}
          editor={editorSession}
          widget={props}
          onCancel={() => {
            closePopup()
          }}
        />
      }

      {view === 'liveElements' &&
        <LiveElementCreationProperty elements={[props]} onCancel={() => closePopup()} />
      }

      {view === "personalization" &&
        <ImagePersonalizationSettings
          uid={props.uid}
          editor={editorSession}
          widget={props}
          onCancel={()=>{
            closePopup()
          }}
        />
      }

      {view === 'hotspot' &&
        <HotspotCreationProperty widget={props} onCancel={() => closePopup()} />
      }

      {!editMode && view === 'action' &&
        <Actions
          target={id}
          editorSession={editorSession}
          value={_.get(props, 'actions.0')}
          onChange={handleActionChange}
          onCancel={() => {
            closePopup()
          }}
        />
      }

      {
        !editMode && view === 'animation' &&
        <AnimationProperty
          ids={[id]}
          editor={editorSession}
          editorContext={editorContext}
          widgets={[props]}
          onCancel={() => {
            closePopup()
          }}
        />
      }

      {view === 'borders' &&
        <BorderPropertyDialog
          editorSession={editorSession}
          widgets={[props]}
          onCancel={() => {
            closePopup();
          }}
        />
      }

      {view === 'alignment' &&
        <ImageAlignmentPropertyDialog
          id={id}
          editorSession={editorSession}
          widget={props}
          onCancel={() => {
            closePopup();
          }}
        />
      }

      {view === 'variables' &&
        <VariableProperty widget={props} onCancel={() => closePopup()} fields={fields} onConfirm={()=>{console.log("uploaded variable")}} />
      }

      {view === 'brandMedia' &&
        <BrandMediaProperty widget={props} onCancel={() => closePopup()} mediaType={'image'} />
      }

    </>
  );
}

export const ImageAltEditor = (props) => {
  const dispatch = useDispatch();

  const [error, setError] = useState(null);

  const alt = _.get(props, `widget.properties.desktop.alt`, '');
  const id = _.get(props, 'widget.uid');
  const imageId = _.get(props, 'widget.content.id') || null;

  const [generating, setGenerating] = useState(false);

  const handleChange = (e) => {
    var value = e.target.value;

    if (!value || value.trim().length === 0) {
      setError("Please enter image alt text")
    } else {
      setError(null);
    }

    dispatch(updateWidgetProperty(props.editor, id, 'desktop', {
      alt: value
    }));
  }

  const handleGenerateText = () => {
    if(generating) {
      return;
    }

    setGenerating(true);
    dispatch(generateAltTextForWidget(id, imageId, (response) => {

      if(response.errors) {
        if(response.errors[0].code === 60001) {
          toast(
            <FailureToast
              heading={`Failure`}
              description={response.errors[0].message}
            />,
            {
              type: toast.TYPE.DEFAULT,
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000,
            }
          );

          setGenerating(false);
        }
      } else {
        dispatch(updateWidgetProperty(props.editor, id, 'desktop', {
          alt: response
        }));
  
        setGenerating(false);
      }
    }));
  }
  return (
    <Property.Dialog
      width={222}
      target={`#${props.id}`}
      className={styles.altTextDialog}
    >
      <Property.Header title={'Alt Text'} className={styles.headerContainer}>
        <Button className={cx(styles.action, styles.confirm, styles.smartIcon)} onClick={handleGenerateText}>
          <Image
            className={styles.pulseImage}
            src={smartGatingIcon}
            width={20}
            height={20}
          />
          <Image
            className={styles.pulseImage2}
            src={smartGatingIcon}
            width={20}
            height={20}
          />
        </Button>
        <Button className={styles.action} onClick={props.onCancel}>
          <i className='cleverstory-close' />
        </Button>
      </Property.Header>
      <Property.Body className={styles.altTextContainer}>
        <Property>
          <p> Add Alt text to all the images for improved accessibility and SEO. Ensure descriptions are clear, aiding screen readers and search engines effectively.</p>
          <textarea
            className={styles.text}
            rows={4}
            value={alt}
            onChange={handleChange}
            placeholder= {generating ? "Generating alt text..." : "Enter alt text"}
            error={error}
          ></textarea>
        </Property>
      </Property.Body>
    </Property.Dialog>
  );
}

export const BorderPropertyDialog = ({ editorSession, widgets, ...rest }) => {
  const dispatch = useDispatch();

  const breakpoint = useSelector(state => _.get(state, `${editorSession}.present.breakpoint`));

  const [borderValue, setBorderValue] = useState({
    border: {
      sides: null,
      color: null,
      width: null,
      radius: {
        lock: false,
        topLeft: "0",
        topRight: "0",
        bottomLeft: "0",
        bottomRight: "0",
      },
    },
    shadow: {
      color: null
    },
  });

  if(widgets?.length === 0) return;

  const widget = widgets[0];
  const id = _.get(widget, 'uid');

  const properties = widgets.length > 1 ? borderValue : _.get(widget, `properties.${breakpoint}`, {});
  const mobileProperties = widgets.length > 1 ? borderValue : _.get(widget, `properties.mobile`, {});

  const { border, shadow } = properties || {};

  const getDifferences = (defaultObj, updatedObj) => {
    const result = {};
  
    Object.keys(updatedObj).forEach((key) => {
      const defaultVal = defaultObj[key];
      const updatedVal = updatedObj[key];
  
      if (_.isObject(updatedVal) && !Array.isArray(updatedVal) && updatedVal !== null) {
        const deepDiff = getDifferences(defaultVal || {}, updatedVal);
        if (Object.keys(deepDiff).length > 0) {
          result[key] = deepDiff;
        }
      } else if (!_.isEqual(defaultVal, updatedVal)) {
        result[key] = updatedVal;
      }
    });
  
    return result;
  }

  const handlePropertyChange = (value) => {
    const widgetIds = widgets.map(w => w.uid);
    const updatedValue = _.omit(value, ['layout']);

    if(_.isEqual(updatedValue, properties)) return;
    const differences = getDifferences(properties, updatedValue);

    dispatch(updateBulkWidgetProperty(editorSession, widgetIds, breakpoint, differences));
    
    if (breakpoint !== 'mobile') {
      const { border: newBorder, shadow: newShadow, ...otherProps } = value;
      
      const mobileUpdate = {
        ...mobileProperties,
        ..._.omit(otherProps, ['layout']),
      };
      
      if (newBorder) {
        mobileUpdate.border = newBorder;
      }
      
      if (newShadow) {
        mobileUpdate.shadow = newShadow;
      }
      
      dispatch(updateBulkWidgetProperty(editorSession, widgetIds, 'mobile', mobileUpdate));
    }

    setBorderValue(updatedValue);
  }

  const handleBorderColor = (value) => {
    const request = {
      ...properties,
      border: {
        ...border,
        color: value,
      }
    }
    handlePropertyChange(request);
  };

  const handleBorderWidthChange = (value) => {
    var request = {
      ...properties,
      border: {
        ...border,
        width: value
      }
    }

    handlePropertyChange(request);
  }

  const handleBorderRadiusChange = (radius) => {
    var request = {
      ...properties,
      border: {
        ...border,
        radius: radius
      }
    }

    handlePropertyChange(request);
  }

  const handleShadowChange = (field, value) => {
    var request = {
      ...properties,
      shadow: {
        ...shadow,
        [field]: value
      }
    }
    handlePropertyChange(request);
  }

  return (
    <>
      <Property.Dialog className={styles.fontDialog}
        width={246}
        target={`#${id}`}
        title={'Border'}
        onCancel={rest.onCancel}
      >
        <Property.Color title={'Color'} clearable={true} value={border?.color} onChange={handleBorderColor} />
        <Property name="Stroke Width" className={styles.buttonStyleProperty}>
          <Property.Slider
            min={0}
            max={10}
            step={1}
            input
            value={border?.width}
            onChange={handleBorderWidthChange}
          />
        </Property>
        <Property name="Corner Radius" className={styles.formStyleProperty}>
          <Property.BorderRadius
            value={border?.radius}
            onChange={handleBorderRadiusChange}
          />
        </Property>
        <DropShadow id={id} widget={widget} properties={shadow} handleShadowChange={handleShadowChange} />
      </Property.Dialog>
    </>
  );
};

const ImageAlignmentPropertyDialog = ({ id, editorSession, widget, ...rest }) => {
  const dispatch = useDispatch();

  const breakpoint = useSelector(state => _.get(state, `${editorSession}.present.breakpoint`));
  const properties = _.get(widget, `properties.${breakpoint}`, {});
  const position = _.get(properties, 'position') || 'center';

  const handlePositionChange = (value) => {
    dispatch(updateWidgetProperty(editorSession, id, breakpoint, {
      position: value
    }));
  }

  return (
    <>
      <Property.Dialog className={styles.fontDialog}
        width={220}
        target={`#${id}`}
        title={'Image Alignment'}
        onCancel={rest.onCancel}
      >
        <Property name="Anchor image to position" className={styles.positionProperty}>
          <div className={styles.body}>
            {Object.keys(POSITION).map(key => {
              const value = POSITION[key];
              const active = position === value;

              return (
                <button className={cx({
                  [styles.active]: active
                })} onClick={() => handlePositionChange(value)}
                >
                  <i className={cx(value === POSITION.CENTER ? "cleverstory-plus" : "cleverstory-back")} />
                </button>
              );
            })}
          </div>
        </Property>
      </Property.Dialog>
    </>
  );
};

function tokensToHtmlWithChips(tokenizedText = "", variables = []) {
  if (!tokenizedText) return "";

  return tokenizedText.replace(/{{\s*([0-9A-Za-z_-]+)\s*}}/g, (m, id) => {
    const v = variables.find((x) => String(x.id) === String(id));

    if (!v) return "";

    const label = v.name || v.label || "";

    // Minimal escaping
    const escLabel = label
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

    return `<span class="variable-chip" contenteditable="false" data-id="${String(
      id
    )}">{${escLabel}}</span>`;
  });
}

function htmlWithChipsToTokensAndIds(html = "") {
  if (!html) return { text: "", ids: [] };

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const chips = doc.querySelectorAll(".variable-chip");
  const ids = [];

  chips.forEach((chip) => {
    const id = chip.getAttribute("data-id");
    if (id != null) {
      ids.push(String(id));

      // Replace chip element with {{id}}
      const tokenText = `{{${String(id)}}}`;
      const tokenNode = doc.createTextNode(tokenText);
      chip.replaceWith(tokenNode);
    }
  });

  const out = doc.body.textContent
    .replace(/\u00A0/g, " ") // convert &nbsp; to space
    .trim();

  return { text: out, ids: _.uniq(ids) };
}

const ImagePersonalizationSettings = ({uid, widget, onCancel }) => {
  const dispatch = useDispatch();
  const editorRef = React.useRef(null);
  const [items, setItems] = useState([]);
  const [view, setView] = useState(null);
  const [initialTokenizedContent, setInitialTokenizedContent] = useState("");
  const [editorHtml, setEditorHtml] = useState("");
  const [saving, setSaving] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;
  const llmProperty = _.get(widget, "properties.desktop.llmProperty", {});
  const storyboard = React.useContext(StoryboardContext);

  const variablesData = useSelector((state) =>
    _.get(state, "variables.items", [])
  );
  const customFormFields = useSelector((state) =>
    _.get(state, "personalization.formFields.items", [])
  );
  const fields = [{ name: "Text", path: "content", type: "TEXT" }];

  useEffect(() => {
    if (variablesData && variablesData.length > 0) {
      setItems(variablesData);
    }
  }, [variablesData]);


  // If you have tokenized content when opening, convert to HTML chips
  useEffect(() => {
    if (!initialTokenizedContent && !editorHtml) {
      // empty editor
      setEditorHtml("");
      return;
    }
    const html = tokensToHtmlWithChips(editorHtml || initialTokenizedContent, [...items, ...customFormFields]);

    if(html) {
      setEditorHtml(html);
    }
    
  }, [initialTokenizedContent, items]);

  // Insert variable from dropdown (expect variable object contains id and name/label)
  const insertVariable = React.useCallback(
    (variable) => {
      if (!editorRef.current) return;
      const editor = editorRef.current;
      const id = String(variable.id);
      const label = variable.name || variable.label || `var_${id}`;
      const escapedLabel = label
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
      const chipHtml = `<span class="variable-chip" contenteditable="false" data-id="${id}">{${escapedLabel}}</span>&nbsp;`;
      editor.insertContent(chipHtml, { format: "raw" });
    },
    [editorRef]
  );

  // Called when Save is clicked: convert html -> tokens, extract ids
  const handleSave = async () => {
    if (!editorRef.current) return;
    const editor = editorRef.current;
    const content = editor.getContent(); // HTML
    const { text: tokenized, ids } = htmlWithChipsToTokensAndIds(content);
    setSaving(true);

    const createVariableAsync = (request) =>
      new Promise((resolve) => {
        dispatch(createVariable(request, (response) => resolve(response)));
      });

    const idMapping = {};

    const creationPromises = ids.map(async (id) => {
      const customFormField = customFormFields.find(
        (field) => String(field.id) === String(id)
      );

      if (customFormField) {
        const existingVariable = items.find(
          (item) => item.customFormField?.id === customFormField.id
        );

        if (existingVariable) {
          idMapping[String(id)] = String(existingVariable.id);
        } else {
          const newVarRequest = {
            name: customFormField.name,
            defaultValue: customFormField.name,
            type: "TEXT",
            storyboard: storyboard.id,
            customFormField: customFormField.id,
          };

          const response = await createVariableAsync(newVarRequest);
          if (response && response.id) {
            idMapping[String(id)] = String(response.id);
          }
        }
      }
    });

    await Promise.all(creationPromises);

    let updatedTokenized = tokenized;
    let updatedIds = [...ids];

    Object.keys(idMapping).forEach((customFormFieldId) => {
      const variableId = idMapping[customFormFieldId];
      const regex = new RegExp(`{{\\s*${customFormFieldId}\\s*}}`, 'g');
      updatedTokenized = updatedTokenized.replace(regex, `{{${variableId}}}`);
      const idIndex = updatedIds.indexOf(customFormFieldId);
      if (idIndex !== -1) {
        updatedIds[idIndex] = variableId;
      }
    });

    setTimeout(() => {
      dispatch(updateWidgetProperty(editorSession, uid, "desktop", {
        llmProperty: {
          prompt: updatedTokenized,
          variables: updatedIds,
        },
      }))
      
      if(_.isEmpty(updatedTokenized)){
        toast(
          <WarningToast
            heading={`Warning`}
            description={`Looks like the prompt is empty! Go ahead and add something to make it personalized.`}
          />,
          {
            type: toast.TYPE.DEFAULT,
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          }
        );
      }
      else{
        toast(
          <SuccessToast
            heading={`Success`}
            description={`The AI Personalization prompt is now in your Image Widget.`}
          />,
          {
            type: toast.TYPE.DEFAULT,
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          }
        );
      }
  
      setSaving(false);
      
      onCancel();
    }, 900);
  };


  useEffect(() => {
    const tokenized = _.get(widget, "properties.desktop.llmProperty.prompt", "") || "";
    setInitialTokenizedContent(tokenized);
  }, [llmProperty]);

  return (
    <>
    <Property.Dialog
      className={styles.imagePersonalizationDialog}
      width={600}
      id={`personalization-dialog-${uid}`}
      target={`#${uid}`}
      title="AI-Personalization Message Composer"
      onCancel={onCancel}
    >
      <Property.Body>
        <div  className={styles.wrapperContainer}>
          <span className={styles.description}>
            Use the variable dropdown to add a variable to your prompt.
          </span>
          <div className={styles.editorContainer}>
          <PromptInputField
            editorRef={editorRef}
            onChange={(content, editor) => {
              setEditorHtml(content);
            }}
            value={editorHtml}
          />
      </div>
          <div className={styles.actionContainer}>
          <Dropdown show={isOpen} onToggle={()=>{setIsOpen(!isOpen)}} className={styles.variableDropDown}>
            <Dropdown.Toggle className={styles.selected}>
              <i className={cx("cleverstory-variable", styles.variableIcon)} />
              Use Variable
            </Dropdown.Toggle>
            <Dropdown.Menu
              className={styles.filterMenu}
              popperConfig={{
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, 8], // controls vertical spacing (8px below the toggle)
                    },
                  },
                  {
                    name: "flip",
                    options: {
                      fallbackPlacements: ["top", "bottom"], // only flip vertically
                    },
                  },
                  {
                    name: "preventOverflow",
                    options: {
                      boundary: "viewport", // avoid escaping the screen
                      altAxis: false,
                      padding: 8,
                    },
                  },
                ],
                  strategy: "fixed",
                }}
            >
              <VaribaleDropdownMenu
                isOpen={isOpen}
                searchable={true}
                onCreateNew={()=>{setView("createVariable")}}
                items={items}
                fieldType={_.head(fields)?.type}
                onSelect={(item) => insertVariable(item)}
              />
            </Dropdown.Menu>
          </Dropdown>

          <Button variant="secondary" disabled={saving} className={styles.saveButton} onClick={handleSave}>
            {saving ? (
              <>
                <span className={styles.savingMessageContainer}>
                  {[...Array(3)].map((_, index) => (
                    <span key={index} className={styles.savingMessage}></span>
                  ))}
                </span>
              </>
            ) : ("Save Changes")}
          </Button>
        </div>
        </div>
      </Property.Body>
    </Property.Dialog>
    { view === "createVariable" && 
        <Property.Dialog
          className={styles.styleDialog}
          width={300}
          title="Create New Variable"
          target={`#${uid}`}
          onCancel={()=>{setView(null)}}
        >
          <Property.Body>
            <CreateVariableForm
              activeDropdown={{ name: "Text", path: "content", type: "TEXT" }}
              onSubmit={()=>{setView(null)}}
              storyboardId={storyboard.id}
            />
          </Property.Body>
      </Property.Dialog>
    }
  </>
  );
}

const PromptInputField = ({ value, onChange, editorRef }) => {

  const [isLoading, setIsLoading] = useState(false);

  const handlePaste = (e) => {
    const clipboardData = e.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData("text");
    e.preventDefault();
    
    
    const sanitized = pastedText.replace(/<[^>]*>/g, "");
    
    
    if (editorRef.current) {
    editorRef.current.execCommand("mceInsertContent", false, sanitized);
    }
  };

  return (
    <>
      {!isLoading && (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingMessage}></div>
        </div>
      )}
      <div className={styles.promptInputContainer}>
        {isLoading && (
          <div className={styles.customPlaceholder} id="custom-placeholder">
            <img src="/images/textAi/aiTextIcon.svg" alt="" className={styles.placeholderIcon}/>
            {!value && (
              <span id="placeholder-text">
                <span className={styles.placeholderLabel}>Describe how this image should change based on</span>
                <span className={styles.placeholderVariable}>{'{Company},'}</span>
                <span className={styles.placeholderVariable}>{'{Industry},'}</span>
                <span className={styles.placeholderLabel}> or </span>
                <span className={styles.placeholderVariable}>{'{Location}'}</span>
              </span>
            )}
          </div>
        )}
    
        <Editor
          tinymceScriptSrc="/tinymce/tinymce.min.js"
          onInit={(evt, editor) => {
            editorRef.current = editor;
            setIsLoading(true);
          }}
          className={styles.customEditorWrapper}
          value={value}
          onEditorChange={onChange}
          init={{
            menubar: false,
            statusbar: false,
            branding: false,
            toolbar: false,
            height: 80,
            max_height: 80,
            min_height: 80,
            quickbars_insert_toolbar: false,
            quickbars_selection_toolbar: false,
            browser_spellcheck: true,
            valid_elements: "*[*]",
            content_css: [],
            plugins: "",
            end_container_on_empty_block: true,
            extended_valid_elements: "span[*],var[*]",
            content_style: `
              body {
                color: #212121; 
                font-size: 12px !important; 
                padding: 13px 15px 15px 31px !important;
                margin: 0px !important;
                line-height: 18px !important; 
                box-sizing: border-box;
              } 
              .variable-chip { 
                background-color: #FFFAE8; 
                borderRadius: 4px; 
                padding: 2px 4px; 
                margin: 0 2px; 
              } 
              p { 
                margin: 0; 
              }
            `,
            setup: (editor) => {
              editor.on('keydown input', () => {
                const placeholderText = document.getElementById('placeholder-text');
                if (placeholderText && editor.getContent()) {
                  placeholderText.style.opacity = '0';
                }
              });
              
              editor.on('change keyup', () => {
                const placeholderText = document.getElementById('placeholder-text');
                if (placeholderText) {
                  if (!editor.getContent() || editor.getContent().trim() === '') {
                    placeholderText.style.opacity = '1';
                  } else {
                    placeholderText.style.opacity = '0';
                  }
                }
              });
              
              editor.on("Paste", handlePaste);
              editor.on("keydown", () => {
                editor.getBody().style.fontSize = "12px";
              });
            },
          }}
        />
      </div>
    </>
  );
};

const ImageWidgetMobileAction = (props) => {
  const dispatch = useDispatch();
  const [view, setView] = useState(null);
  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;

  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const brandkitEnabled = _.get(workspace, 'brandkitEnabled', false);
  const brandkitType = useSelector((state) =>
    _.get(state, `${editorSession}.present.entityType`)) !== 'PALETTE_COMPONENT'; 

  const isHotspotContainer = useHotspotContainerSelector(editorSession, props);
  const allowLiveElement = useAllowCreateLiveElement(editorSession, props);
  const isBrandImageContainer = useBrandImageContainerSelector(editorSession, props);
  const allowBrandkit = !isBrandImageContainer && brandkitType;  

  const id = _.get(props, 'uid');
  const parameterised = _.get(props, 'parameter');

  const editMode = useSelector(state => {
    return _.get(state, `${editorSession}.present.editMode`) === id
  });

  const changeView = (view) => {
    dispatch(toggleEditMode(editorSession, props.uid, false));
    setView(view);
  }

  const handleLiveElement = () => {
    setView('liveElements')
  }
  const closePopup = () => {
    dispatch(toggleEditMode(editorSession, props.uid, false));
    setView(null);
  }

  return (
    <>
      {!parameterised &&
        <>
          <WidgetActions.Action className={styles.cropButton} tooltip='Crop' onClick={() => {
            dispatch(toggleEditMode(props.editorSession, props.uid, true));
          }}>
            <i className={'cleverstory-crop'} />
          </WidgetActions.Action>
          <WidgetActions.Divider />
        </>
      }

      <Property.Action className={styles.iconButton} tooltip='Border' onClick={() => changeView('borders')}>
        <i className={cx("cleverstory-corner", styles.gridIcon)} />
      </Property.Action>

      {parameterised &&
        <Property.Action className={styles.iconButton} tooltip='Style' onClick={() => changeView('alignment')}>
          <i className={cx("cleverstory-customize")} />
        </Property.Action>
      }

      <Property.Action className={styles.iconButton} tooltip='Animation' onClick={() => changeView('animation')}>
        <i className={'cleverstory-animations'} />
      </Property.Action>

      {allowLiveElement &&
        <Property.Action className={styles.iconButton} tooltip='Live Element' onClick={handleLiveElement}>
          <i className={'cleverstory-live-element'} />
        </Property.Action>
      }
      {!parameterised && brandkitEnabled && allowBrandkit && userRoleService.canManageUsers() &&
        <Property.Action className={styles.iconButton} tooltip='Add to Brand Kit' onClick={() => changeView('brandMedia')}>
          <i className={'cleverstory-brandmedia'} />
        </Property.Action>
      }

      {!parameterised && !isHotspotContainer &&
        <HotspotActionButton onClick={() => changeView('hotspot')} widget={props} />
      }

      <WidgetActions.Divider />

      {!editMode && view === 'animation' &&
        <AnimationProperty
          ids={[id]}
          editor={editorSession}
          editorContext={editorContext}
          widgets={[props]}
          onCancel={() => {
            closePopup()
          }}
        />
      }

      {view === 'borders' &&
        <BorderPropertyDialog
          editorSession={editorSession}
          widgets={[props]}
          onCancel={() => {
            closePopup();
          }}
        />
      }

      {view === 'alignment' &&
        <ImageAlignmentPropertyDialog
          id={id}
          editorSession={editorSession}
          widget={props}
          onCancel={() => {
            closePopup();
          }}
        />
      }
      {view === 'liveElements' &&
        <LiveElementCreationProperty elements={[props]} onCancel={() => closePopup()} />
      }

      {view === 'hotspot' &&
        <HotspotCreationProperty widget={props} onCancel={() => closePopup()} />
      }
      {view === 'brandMedia' &&
        <BrandMediaProperty widget={props} onCancel={() => closePopup()} mediaType={'image'} />
      }
    </>
  );
}

ImageWidget.sizeConfig = async (widget, mediaCache) => {  
  if (!_.get(widget, 'content.url')) {
    return {
      size: 0,
      type: 'image'
    };
  }

  return {
    size:  await getMediaInfo(`${IMAGE_CDN_ENDPOINT}/${_.get(widget, 'content.url', '')}`, mediaCache) || 0, // in MB
    type: 'image'
  };
}

ImageWidget.moveableConfig = (editorSession, widget) => {
  const contentCard = getParentContainerOfType(editorSession, widget.uid, CONTENT_CARD);
  var bounds = null;

  if (contentCard) {
    bounds = calculateBoundsForElement(contentCard);
  }

  var id = widget && widget.uid ? widget.uid : null;
  const group = getParentContainerOfType(editorSession, id, GROUP);

  const isLoadingWidget = id && (
    id.includes('widget_loading') || 
    id.toLowerCase().startsWith('widget_loading')
  );

  if (isLoadingWidget) {
    return {
      draggable: false,
      resizable: false,
      rotatable: false,
      cloneable: false,
      deletable: false,
      bounds: bounds,
      renderDirections: false,
      onReparent: () => false
    };
  }

  return {
    draggable: true,
    resizable: true,
    rotatable: true,
    cloneable: true,
    deletable: true,
    bounds: bounds,
    renderDirections: ["n", "s", "ne", "nw", "se", "sw", "e", "w"],
    onReparent: (widget, parent) => {
      let hasTopParentIsHotspot = false;
      const parentWidget = getParentContainerOfType(editorSession, widget, CONTENT_CARD);

      const hasHotspotChild = isWidgetHasHotspotChild(editorSession, widget);
      const parentType = getWidgetType(editorSession, parent);

      if (parentType === CAROUSEL_CARD){
        hasTopParentIsHotspot = isTopParentIsHotspot(editorSession, parent, CAROUSEL);
      }

      const denyHostpotReparent = hasHotspotChild && ![PAGE, SECTION_COLUMN, CONTAINER, CAROUSEL_CARD, MENU, FORM_STEP].includes(parentType);

      if (parentWidget || group || denyHostpotReparent || (hasHotspotChild && hasTopParentIsHotspot)) {
        return false;
      }

      return true;
    }
  }
}

ImageWidget.actions = (editorSession, breakpoint, props) => {
  const id = _.get(props, 'uid');
  const isLoadingWidget = id && (
    id.includes('widget_loading') || 
    id.toLowerCase().startsWith('widget_loading')
  );

  if (isLoadingWidget) {
    return false;
  }

  if (breakpoint === 'desktop') {
    return (
      <ImageWidgetDesktopAction
        editorSession={editorSession} {...props}
      />
    );
  } else if (breakpoint === 'mobile') {
    return (
      <ImageWidgetMobileAction
        editorSession={editorSession} {...props}
      />
    );
  }

  return false;
}

ImageWidget.flexFlow = { preserveSize: true };

ImageWidget.processRequest = (widget) => {
  var content = _.get(widget, 'content.id');
  const actions = _.get(widget, 'actions');

  const updated = (actions || []).map((action)=>{
    if(action.type == 'asset'){
      const value = _.get(action, 'value.content.id') || _.get(action, 'value', null);
      return {
        ...action,
        value: value
      }
    }
    return action
  })

  return {
    ...widget,
    content: content,
    actions: updated
  }
}

function getStyles(properties, breakpoint, crop) {
  var styles = {};

  if (!properties) {
    return styles;
  }

  const deviceProperties = _.get(properties, `properties.${breakpoint}`);

  const topLeft = _.get(deviceProperties, 'border.radius.topLeft', null);
  const topRight = _.get(deviceProperties, 'border.radius.topRight', null);
  const bottomLeft = _.get(deviceProperties, 'border.radius.bottomLeft', null);
  const bottomRight = _.get(deviceProperties, 'border.radius.bottomRight', null);
  const border = _.get(deviceProperties, 'border', null);

  if(!crop){
    if (topLeft) {
      styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
    }

    if (topRight) {
      styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
    }

    if (bottomLeft) {
      styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
    }

    if (bottomRight) {
      styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
    }

    const colorRgb = _.get(deviceProperties, 'border.color');

    var color = 'transparent';
    if (colorRgb) {
      color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
    }

    styles['borderColor'] = color;

    const borderWidthString = _.get(deviceProperties, 'border.width', null) || "0";
    var borderWidget = parseInt(borderWidthString) + 'px';

    styles['borderWidth'] = borderWidget;
    styles['borderStyle'] = border ? "none" : "solid"

    const objectPosition = getImagePosition(_.get(deviceProperties, 'position'));
    styles['objectPosition'] = objectPosition;

    //DropShadow
    const shadow = _.get(deviceProperties, `shadow`, null);
    const shadowStyle = getDropShadow(shadow);
    styles = {
      ...styles,
      ...shadowStyle
    }
  }

  return styles;
}

function getBorderStyles(value) {
  if (!value) {
    return null;
  }

  var styles = {};
  const topLeft = _.get(value, 'radius.topLeft', null);
  const topRight = _.get(value, 'radius.topRight', null);
  const bottomLeft = _.get(value, 'radius.bottomLeft', null);
  const bottomRight = _.get(value, 'radius.bottomRight', null);

  const colorRgb = _.get(value, 'color', "transparent");

  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }

  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }

  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }

  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }

  var color = 'transparent';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  styles['borderColor'] = color;

  const borderWidthString = _.get(value, 'width', '0');
  var borderWidget = parseInt(borderWidthString) + 'px';

  styles['borderWidth'] = borderWidget;
  // Only fill behind the image when there is an actual border to fill. A
  // zero-width border still carries a colour (getComputedStyle resolves an
  // undeclared border-color to currentColor, usually black), and painting that
  // as a background puts a black plate behind every transparent PNG.
  if (parseInt(borderWidthString, 10) > 0) {
    styles['backgroundColor'] = color;
  }
  styles['borderStyle'] = "solid";
  styles['overflow'] = "hidden";

  return styles;
}

function getImagePosition(position) {
  var backgroundPosition = 'center center';

  switch (position) {
    case POSITION.TOP_LEFT:
      backgroundPosition = 'left top';
      break;

    case POSITION.TOP_CENTER:
      backgroundPosition = 'center top';
      break;

    case POSITION.TOP_RIGHT:
      backgroundPosition = 'right top';
      break;

    case POSITION.CENTER_LEFT:
      backgroundPosition = 'left center';
      break;

    case POSITION.CENTER:
      backgroundPosition = 'center center';
      break;

    case POSITION.CENTER_RIGHT:
      backgroundPosition = 'right center';
      break;

    case POSITION.BOTTOM_LEFT:
      backgroundPosition = 'left bottom';
      break;

    case POSITION.BOTTOM_CENTER:
      backgroundPosition = 'center bottom';
      break;

    case POSITION.BOTTOM_RIGHT:
      backgroundPosition = 'right bottom';
      break;
  }

  return backgroundPosition;
}

export { ImageWidget };